import { adminHttpClient } from '../../../commons/adminHttpClient'

export type DefinePerksBenefitRedesignDecisionRequest = {
  useSame: boolean
}

export const definePerksBenefitRedesignDecision = (
  payload: DefinePerksBenefitRedesignDecisionRequest,
): Promise<any> => {
  return adminHttpClient.put('/Benefit/BenefitRenewal/Perks/SetBenefitRedesignDecision', payload)
}
export default definePerksBenefitRedesignDecision
